// SSOT de textos do módulo Auditoria (UTF-8)
export const AUDITORIA_TITLE = 'Auditoria'
export const AUDITORIA_DESC = 'Oportunidades com relatos de bug enviados pelos usuários'
export const PER_PAGE_LABEL = 'por página:'
export const NO_ITEMS_TEXT = 'Nenhuma oportunidade marcada para auditoria.'
export const LOADING_TEXT = 'Carregando...'

